export default __webpack_public_path__ + "static/media/ele_example_4_3.020a1e94.png";